import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/works';
import { typeLabel } from '@/utils/works';

interface WorkCardProps {
  work: Work;
  showSynopsis?: boolean;
}

export default function WorkCard({ work, showSynopsis = false }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className="group block cursor-pointer"
      title={`${work.title} - ${typeLabel(work.type)}详情`}
    >
      <div className="relative w-full aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={work.cover}
          alt={`${work.title} 海报`}
          title={`${work.title} ${typeLabel(work.type)}封面`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-primary-600/90 text-background-50 backdrop-blur">
          {typeLabel(work.type)}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-0.5 px-2 py-0.5 rounded-md text-[11px] font-medium bg-accent-500 text-secondary-950">
          <i className="ri-star-fill text-[10px]" aria-hidden="true"></i>
          {work.rating.toFixed(1)}
        </span>

        <div className="absolute inset-x-0 bottom-0 p-3 translate-y-3 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
          <p className="text-[12px] leading-snug text-background-100 line-clamp-3">
            {work.synopsis.slice(0, 60)}…
          </p>
          <span className="mt-2 inline-flex items-center gap-1 text-[11px] text-accent-400">
            查看详情
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </span>
        </div>
      </div>

      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-700 transition-colors">
          {work.title}
        </h3>
        {showSynopsis ? (
          <p className="mt-1 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
            {work.synopsis}
          </p>
        ) : (
          <p className="mt-1 text-xs text-foreground-500 truncate">
            {work.year} · {work.region} · {work.genres.join(' / ')}
          </p>
        )}
      </div>
    </Link>
  );
}